//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductViewDetail',
  data() {
    return {
      detailList: {}, // 详情列表
      loanSubsidyLimitNum: '', // 年利率
      businessOutlets: '', // 业务网点
    }
  },
  created() {
    this.getSelectOneList()
    this.businessOutlets = this.$route.query.businessOutlets
  },
  methods: {
    getSelectOneList() {
      let params = {
        id: this.$route.query.id,
      }
      this.$http.bank.getSelectOneList(params).then((res) => {
        this.detailList = res.data
        let num = res.data.maxYearRate / res.data.minYearRate
        this.loanSubsidyLimitNum = Math.round(num * 100) / 100
      })
    },
  },
}
